const bg = "_bg_610zp_8";
const drawer = "_drawer_610zp_17";
const body = "_body_610zp_51";
const drawerMenu = {
  bg,
  drawer,
  body
};
export {
  bg,
  body,
  drawerMenu as default,
  drawer
};
//# sourceMappingURL=DrawerMenu.module.css.js.map
